import { type ReactNode, useMemo } from 'react';

import { type MessageDescriptor, useIntl } from 'react-intl-next';

import { functionWithFG } from '@atlaskit/platform-feature-flags-react';

import type { FallbackUrl, GlobalShortcutLinkItem } from '../../types';

export const useAppGlobalShortcutLinkItem = functionWithFG(
	'navx-3138-gas-menu-rendering-perf-fix',
	useAppGlobalShortcutLinkItemNEW,
	useAppGlobalShortcutLinkItemOLD,
);

function useAppGlobalShortcutLinkItemNEW(
	icon: ReactNode,
	label: MessageDescriptor,
	fallbackUrl: FallbackUrl,
	options?: Pick<
		GlobalShortcutLinkItem,
		'labelElem' | 'apsKey' | 'ref' | 'analyticsName' | 'menuItemId'
	>,
): GlobalShortcutLinkItem {
	const { labelElem, apsKey, ref, analyticsName, menuItemId } = options ?? {};
	const { formatMessage } = useIntl();
	const labelText = formatMessage(label);

	return useMemo(
		() => ({
			type: 'link',
			icon,
			label: labelText,
			labelElem,
			apsKey,
			fallbackUrl,
			ref,
			analyticsName,
			...(menuItemId ? { menuItemId } : {}),
		}),
		// Intentionally remove the ref, as it isn't needed by useMemo, and can cause extra rendering.
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[analyticsName, apsKey, fallbackUrl, icon, labelElem, labelText, menuItemId],
	);
}

function useAppGlobalShortcutLinkItemOLD(
	icon: ReactNode,
	label: MessageDescriptor,
	fallbackUrl: FallbackUrl,
	options?: Pick<
		GlobalShortcutLinkItem,
		'labelElem' | 'apsKey' | 'ref' | 'analyticsName' | 'menuItemId'
	>,
): GlobalShortcutLinkItem {
	const { labelElem, apsKey, ref, analyticsName, menuItemId } = options ?? {};
	const { formatMessage } = useIntl();

	return useMemo(
		() => ({
			type: 'link',
			icon,
			label: formatMessage(label),
			labelElem,
			apsKey,
			fallbackUrl,
			ref,
			analyticsName,
			...(menuItemId ? { menuItemId } : {}),
		}),
		[apsKey, fallbackUrl, icon, formatMessage, labelElem, label, ref, analyticsName, menuItemId],
	);
}
